import * as React from 'react';
import { Box } from '../../ui/box/box';
import { DateField } from './fields/date/date';
import { HandOverField } from './fields/HandOver';
import { PriceField } from './fields/price/price';
import { RegionField } from './fields/region/region';
import { RoomsField } from './fields/room/room';
import { SquareField } from './fields/square/square';
import { WithDesignField } from './fields/with_design/with_design';
const styles = require('./filters.css');
const fieldStyles = require('./fields/fields.css');

export class Filters extends React.PureComponent<object, object> {
  public render() {
    return (
      <div className={styles['wrapper']}>
        <div className={styles['filters']}>
          <div className={styles['filters-row']}>
            <Box right={30} boxStyles={fieldStyles.field}>
              <RegionField />
            </Box>
            <Box right={30} boxStyles={fieldStyles.field}>
              <DateField />
            </Box>
            <Box right={30} boxStyles={fieldStyles.field}>
              <RoomsField />
            </Box>
            <Box right={20} boxStyles={fieldStyles.field}>
              <HandOverField />
            </Box>
          </div>
          <div className={styles['filters-row']}>
            <Box right={20} boxStyles={fieldStyles.field}>
              <SquareField />
            </Box>
            <Box right={30} boxStyles={fieldStyles.field}>
              <PriceField />
            </Box>
            <Box right={20} boxStyles={fieldStyles.field}>
              <WithDesignField />
            </Box>
          </div>
        </div>
      </div>
    );
  }
}
